import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material'
import styled from '@emotion/styled'
import { useTheme } from '@mui/system'

import { Button, ButtonVariant } from 'src/system/ui/button/Button'

const DISCORD_URL = 'https://pureskill.gg/discord'

const KNOWN_ERROR_CODES = new Set([
  'demo_not_found',
  'demo_error',
  'replay_error',
  'ppp_error',
  'sharecode_error',
  'metademo_error'
])

const DISCORD_ERROR_CODES = new Set(['replay_error', 'ppp_error', 'unknown'])

export function ErrorCodeModal(props: {
  errorCode: string
  isVisible: boolean
  onClose: () => void
}) {
  const { t } = useTranslation()
  const theme = useTheme()

  const code = KNOWN_ERROR_CODES.has(props.errorCode)
    ? props.errorCode
    : 'unknown'
  const prefix = `matches:error_modal.${code}`
  const title = t(`${prefix}.title`)
  const body = t(`${prefix}.body`)
  const buttonLabel = t(`${prefix}.button`)
  const opensDiscord = DISCORD_ERROR_CODES.has(code)

  function handleButton() {
    if (opensDiscord) {
      window.open(DISCORD_URL, '_blank', 'noopener,noreferrer')
    }
    props.onClose()
  }

  return (
    <Dialog open={props.isVisible} onClose={props.onClose}>
      <DialogContent>
        <DialogTitle>{title}</DialogTitle>
        <DialogContentText>{body}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <StyledButton
          onClick={handleButton}
          variant={ButtonVariant.primary}
          color={opensDiscord ? theme.d.colors.discord.blurple : undefined}
        >
          {buttonLabel}
        </StyledButton>
      </DialogActions>
    </Dialog>
  )
}

const StyledButton = styled(Button)`
  text-transform: uppercase;
`
